import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ScopeAndSequenceWrapper from "./routes/ScopeAndSequenceWrapper";
import ACLStore from "lib/aclStore";
import { ENABLE_STANDARDS_V2 } from "Constants/permissionConstants";

export default store => ({
  path: "scopeandsequence",
  component: ACLStore.can(ENABLE_STANDARDS_V2)
    ? null
    : withAsyncRouteLoading(() =>
        Promise.all([
          import(
            /* webpackChunkName: "organization-educatorCenter" */ "MultiLevelNodeEditor/components"
          ),
          import(
            /* webpackChunkName: "organization-educatorCenter" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
          ),
          import(
            /* webpackChunkName: "organization-educatorCenter" */ "SubjectsSetup/modules/SubjectsModule"
          ),
        ]).then(([importedModule0, importedModule1, importedModule2]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const subjectSetupReducer = importedModule2.default;
          injectReducer(store, {
            key: "subjectsSetup",
            reducer: subjectSetupReducer,
          });
          injectReducer(store, {
            key: "multiLevelNodeEditor",
            reducer,
          });
          return component;
        })
      ),
  childRoutes: [ScopeAndSequenceWrapper(store)],
});
